import React from 'react';
import { Link } from 'react-router-dom';
import LearnArrow from '../img/color_arrow.png';

export default function (props) {
  const i = props && props.index;
  const item = props.item; 
  return<>
    <div className='blog_box'>
      <div className='blog_content'>
        <div className='postdate'>{item.postDate}</div>
          <h3><Link to="/">{item.postTitle}</Link></h3>
            {(i === 0) ? <Link to="/" className="learn_more">Learn More <img src={LearnArrow} alt="arrow" /></Link> : null}
        </div>
        <div className='blog_img'>
          <img src={`${item.postImg}`} alt="img"/>
        </div>
    </div>
  </>
}
